import { EndpointInterface } from '../../core'
import {
  DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_ACTIVATION,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_FORGOT_PASSWORD,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PASSWORD,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PASSWORD_RESET,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PIN,
  ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_EMAIL_CHANGE,
} from '../constants'
import type {
  AccessManagementAccountGetResponse,
  AccessManagementAccountPutResponse,
  AccessManagementAccountActivatePostPayload,
  AccessManagementAccountPutPayload,
  AccessManagementAccountResetPasswordPostPayload,
  AccessManagementAccountPasswordPostPayload,
  AccessManagementAccountPinPostPayload,
  AccessManagementAccountActivatePostResponse,
  AccessManagementAccountForgotPasswordPostPayload,
} from '../types'

export const getAccessManagementAccount =
  ({
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    apiVersion?: string
  }): EndpointInterface<AccessManagementAccountGetResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT,
        params: [apiVersion],
      },
      method: 'get',
    })

export const putAccessManagementAccount =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountPutPayload
    apiVersion?: string
  }): EndpointInterface<AccessManagementAccountPutResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT,
        params: [apiVersion],
      },
      method: 'put',
      data,
    })

export const postAccessManagementAccountActivation =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountActivatePostPayload
    apiVersion?: string
  }): EndpointInterface<AccessManagementAccountActivatePostResponse> =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_ACTIVATION,
        params: [apiVersion],
      },
      method: 'post',
      data,
    })

export const postAccessManagementAccountEmailChange =
  ({
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    apiVersion?: string
  }): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_EMAIL_CHANGE,
        params: [apiVersion],
      },
      method: 'post',
    })

export const postAccessManagementAccountPasswordReset =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountResetPasswordPostPayload
    apiVersion?: string
  }): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PASSWORD_RESET,
        params: [apiVersion],
      },
      method: 'post',
      data,
    })

export const postAccessManagementAccountPassword =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountPasswordPostPayload
    apiVersion?: string
  }): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PASSWORD,
        params: [apiVersion],
      },
      method: 'post',
      data,
    })

export const postAccessManagementAccountPin =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountPinPostPayload
    apiVersion?: string
  }): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_PIN,
        params: [apiVersion],
      },
      method: 'post',
      data,
    })

export const postAccessManagementAccountForgotPassword =
  ({
    data,
    apiVersion = DEFAULT_ACCESS_MANAGEMENT_API_VERSION,
  }: {
    data: AccessManagementAccountForgotPasswordPostPayload
    apiVersion?: string
  }): EndpointInterface =>
  (provider) =>
    provider({
      url: {
        endpoint: ENDPOINT_ACCESS_MANAGEMENT_ACCOUNT_FORGOT_PASSWORD,
        params: [apiVersion],
      },
      method: 'post',
      data,
    })
